// import en from '@vueform/vueform/locales/en'
import en from './src/locales/index'
import bootstrap from '@vueform/vueform/dist/bootstrap'
import { defineConfig } from '@vueform/vueform'
import {
  required_if,
  required_with,
  required_with_all,
  required_without,
  required_without_all,
} from './src/validation/vueformCustomRules'

export default defineConfig({
  theme: bootstrap,
  locales: { en },
  locale: 'en',
  rules: {
    required_if,
    required_with,
    required_with_all,
    required_without,
    required_without_all,
  },
})